import { render, staticRenderFns } from "./addToReference.vue?vue&type=template&id=e4021de6&scoped=true&"
import script from "./addToReference.vue?vue&type=script&lang=js&"
export * from "./addToReference.vue?vue&type=script&lang=js&"
import style0 from "./addToReference.vue?vue&type=style&index=0&id=e4021de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4021de6",
  null
  
)

export default component.exports